import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { fetchTokensListApi } from '../../api/tokens-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  tokens: [],
  types: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchTokensListing = createAsyncThunk('tokens/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchTokensListApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const TokensSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    setTokensLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setTokensActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTokensListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchTokensListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.tokens = action?.payload?.data || [];
        state.types = action?.payload?.types || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchTokensListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setTokensActiveColumn, setTokensLoading } = TokensSlice.actions;
export default TokensSlice.reducer;
